import React from "react";
import PropTypes from "prop-types";
// import css from 'cape-style'
import {  filter, sampleSize, sample } from "lodash"
import ReactPlayer from 'react-player'

import StudentInfo from "./StudentInfo";
import ShowInfo from "./ShowInfo";
import ProgramList from "./ProgramList";
import Wrapper from "../Wrapper/WrapperEl";
import ImageStack from "./ImageStack";
import ImageHeaderMobile from "./ImageHeaderMobile";
import ImageStackMobile from "./ImageStackMobile";
import NoImages from "./NoImages";
import Logo from "../Logo/Logo";
import Slideshow from "../Slideshow/SlideTest";
import SlideThumb from "./SlideThumb"
import Peers from '../Peers/Peers'

import mgsLogo from "../../mgs2018logoarrow.svg";

import {
  Flex,
  ImageContainer,
  InfoContainer,
  Divider,
  Back,
  Loading,
  SlideTitle,
  VideoContainer
} from "./styles";

function ProgramDetail({ closePopup, program, studentArt, allStudentArt }) {
  let picked = null
  if ( allStudentArt && allStudentArt.length > 0 && program && program.id ) {
    const filtered = filter(allStudentArt, { program: program.id })
    picked = sampleSize(filtered, 12)
  }
  const profileImg = program && program.profileImage && sample(program.profileImage)
  console.log(profileImg)

  return (
    <Wrapper>
      <Back onClick={closePopup}>
        <Logo primary left logoSrc={mgsLogo} siteName="MICA Grad Show 2020" />
      </Back>
      {!program && <Loading className="flex loading">loading...</Loading>}
      {program && (
        <Flex>
          <ImageContainer>
            {console.log()}
            {profileImg && (
            //   <SlideThumb
            //   key={profileImg.id}
            //   src={profileImg.url}
            //   // title={item.title}
            //   // videoInfo={item.videoInfo}
            //   // handleClick={item.handleClick}
            //   // width={item.width}
            //   // event={item.event}
            //   // person={item.person}
            // />
            <img
            srcSet={`${profileImg.url}?w=2048 2048w,
                     ${profileImg.url}?w=1792 1792w,
                     ${profileImg.url}?w=1536 1536w,
                     ${profileImg.url}?w=1280 1280w,
                     ${profileImg.url}?w=1024 1024w,
                     ${profileImg.url}?w=768 768w,
                     ${profileImg.url}?w=512 512w`}
            src={profileImg.url}
            sizes="(min-width: 48rem) 66.66vw, 100vw"
          />
            )}
            {/* {!program.profileImage && <NoImages />} */}
          </ImageContainer>

          <InfoContainer>
            {console.log(program)}
            <StudentInfo {...program} />
            <Divider />
            {program._refs.showGroup && sample(program._refs.showGroup).id === 'rec47bbcAmGcy06c0' && (
              <div>
                <ShowInfo />
                <Divider />
              </div>
            )}

            <ProgramList id={program.id} />
          </InfoContainer>
        </Flex>
      )}
      {picked && picked.length > 0 && (
          <SlideTitle>Student Work</SlideTitle>
      )}
      {picked && picked.length > 0 && (
          <Slideshow collection={picked} />
      )}
    </Wrapper>
  );
}

ProgramDetail.propTypes = {
  closePopup: PropTypes.func.isRequired,
  program: PropTypes.shape({
    id: PropTypes.string.isRequired
  })
};
ProgramDetail.defaultProps = {
  program: null
};
export default ProgramDetail;



// WEBPACK FOOTER //
// ./src/components/ProgramsDetail/ProgramsDetailEl.jsx